<lib-dialog
  class="container"
  [title]="'customer-selection-form.text.title' | translate"
  [scrollToTopTrigger]="scrollToTopTrigger"
  (closeButtonClick)="closeDialog()"
  (scrolledToTheEnd)="addMoreFilteredCustomers()"
>
  <div header class="flex-row-space-between" style="gap: 5px; margin-top: 5px">
    <mat-form-field>
      <mat-label>{{
        'customer-selection-form.text.search_field_label' | translate
      }}</mat-label>
      <input [formControl]="searchKeywordControl" matInput type="search" />
      <button
        *ngIf="searchKeywordControl.value"
        mat-icon-button
        matSuffix
        (click)="searchKeywordControl.setValue(null)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <button
      mat-flat-button
      color="primary"
      class="add-new-customer-button"
      (click)="openCustomerFormDialog()"
    >
      <mat-icon>person_add</mat-icon>
      <span>{{
        'customer-selection-form.buttons.create_new_customer_profile'
          | translate
      }}</span>
    </button>
  </div>

  <div body style="width: 99%">
    <table>
      @for(customer of filteredCustomersToDisplay; track customer.id) {
      <tr>
        <td
          class="flex-row-space-between"
          [class.highlight-text]="isCustomerSelected(customer.id)"
        >
          <div class="cell-container">
            <div>
              <strong>
                {{
                  customer | customerNameFormatter : businessObject?.telephone
                }}
              </strong>
            </div>
            <div *ngIf="customer?.phoneNr">{{ customer.phoneNr }}</div>
            <div *ngIf="customer?.email">{{ customer.email }}</div>
          </div>
        </td>

        <td class="additional-info">
          <div class="cell-container">
            <div>
              <lib-customer-type-badge
                [customerType]="customer.type"
              ></lib-customer-type-badge>
            </div>
            <div *ngIf="customer?.note?.length" style="margin-top: 5px">
              {{ customer.note }}
            </div>
          </div>
        </td>

        <td class="select-button-container">
          <ng-container
            [ngTemplateOutlet]="selectButtonTemplate"
            [ngTemplateOutletContext]="{ customer: customer }"
          ></ng-container>
        </td>
      </tr>
      }
    </table>
  </div>

  <ng-container action>
    <lib-spacer></lib-spacer>
    <button mat-stroked-button color="primary" (click)="closeDialog()">
      {{ 'customer-selection-form.buttons.close' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>

<ng-template #selectButtonTemplate let-customer="customer">
  <button
    *ngIf="isCustomerSelected(customer?.id)"
    mat-flat-button
    color="primary"
  >
    {{ 'customer-selection-form.buttons.selected' | translate }}
  </button>
  <button
    *ngIf="!isCustomerSelected(customer?.id)"
    mat-stroked-button
    color="primary"
    (click)="selectCustomer(customer)"
  >
    {{ 'customer-selection-form.buttons.select' | translate }}
  </button>
</ng-template>
